import React from 'react';
import './Footer.css'; // Import the custom CSS file

const Footer = () => {
    return (
        <footer className="footer-container">
            <div className="container">
                <h1>Contact Info</h1>
                <p>Email: ramielite@yahoo.com</p>
                <p>Phone: (551) 339-3339</p>
                <div className="social-media">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                        Facebook
                    </a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                        Instagram
                    </a>
                </div>
                <hr />
                <p>© {new Date().getFullYear()} Rami Elite. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;